import { FilterTypes } from '../../../../modules/sortAndFilter/workers/sortAndFilter';
import Filter from './Filter';

class ActiveIngredientFilter extends Filter<string> {
    constructor(type: FilterTypes['type'], urlKey: string) {
        super(type, urlKey);
        this.setKeysFromUrl();
    }
}

export default ActiveIngredientFilter;
